module.exports = __webpack_public_path__ + "images/bug_yellow_size_5_0164e78fe4948cc27b4c4b5da25e0557.png";